<script>
	import { splitCamelCaseAndCapitalize } from "src/utils/misc";
	import { createEventDispatcher, onMount } from "svelte";
	import {
		bookingId,
		damageReviewed,
		imageLightbox,
		vehicleId,
		damageReviewedData,
	} from "../../store/store";
	import Lightbox from "../Lightbox/Lightbox.svelte";
	import CustomInfiniteSelect from "../CustomSelect/CustomInfiniteSelect.svelte";

	export let data;
	export let title;
	export let reviewed;
	export let lightbox = false;
	export let detectDamages = false;
	export let boxes = []; // [x1, x2, y1, y2]
	export let origShape = []; // [Height, Width]
	export let caseManagement = false;

	// NEW props from parent
	export let options = []; // options to be shown in the dropdown
	export let onScrollChange = () => {}; // triggered on scroll to end
	export let onSelectReport = () => {}; // triggered on report selection
	export let onLoadMore = () => {};
	export let value = null;

	let idx = 0;
	let isOpen = false;
	let selectedOption = null;
	let dispatch = createEventDispatcher();
	let arr = $damageReviewedData; // to store the attribution data

	$: if (data?.images && data.images.length > 0) {
		for (const img of data.images) {
			if (!("damageAttribute" in img)) {
				img.damageAttribute = "none";
			}
		}
	}

	function handleOpenLightBox(i, image) {
		imageLightbox.set([]);
		idx = Number(i);
		isOpen = true;
		imageLightbox.set(image.map((img) => img.imgUrl));
	}

	function handleAttributionChange(e) {
		if (!data?.images || !data.bookingId || !data.vehicleId) return;

		data.images[idx].damageAttribute = e.target.value;
		// check if object with bookingId already exists in the store
		const existingIndex = arr.findIndex(
			(item) => item.bookingId === data.bookingId
		);
		if (existingIndex !== -1) {
			// if exists, update the existing object
			arr[existingIndex].images.damageAttribute =
				data.images[idx].damageAttribute;

			const allNone = arr[existingIndex].images.every(
				(item) => item.damageAttribute === "none"
			);
			if (allNone) {
				arr.splice(existingIndex, 1);
			}
			damageReviewedData.set(arr);
			return;
		}

		arr.push(data);
		damageReviewedData.set(arr);
		dispatch("localDataUpdated");
	}

	function handleAttributionOnMount() {
		// check store for existing attribution data
		// if store has data with bookingId and uid and imgSide, set the data.images[idx].damageAttribute
		if (!data?.images || !data.bookingId || !data.vehicleId) return;

		const existingIndex = arr.findIndex(
			(item) => item.bookingId === data.bookingId
		);
		if (existingIndex !== -1) {
			data = arr[existingIndex];
		}
	}

	$: if (typeof idx === "number") {
		handleAttributionOnMount();
	}

	// onMount(() => {
	// 	damageReviewedData.set(data);
	// });
</script>

{#if data === null}
	<div
		class="d-flex flex-column review-container p-3 mr-1"
		style="height: 100%"
	>
		<h4 class="d-flex justify-content-center w-100 my-2">
			<b> {title} </b>
		</h4>
		<div class="d-flex flex-column my-2 py-2 info-category">
			<span class="description">&nbsp;</span>
			<span>&nbsp;</span>
		</div>
		<div
			class="d-flex justify-content-center align-items-center w-100 h-100 my-2"
		>
			<h5>
				{title === "Last Reviewed"
					? "This vehicle has not been reviewed yet."
					: "Good job! All damages have been reviewed."}
			</h5>
		</div>
	</div>
{:else if $damageReviewed && title === "Last Report"}
	<div
		class="d-flex flex-column review-container p-3 mr-1"
		style="height: 100%"
	>
		<h4 class="d-flex justify-content-center w-100 my-2">
			<b> {title} </b>
		</h4>
		<div class="d-flex flex-column my-2 py-2 info-category">
			<span class="description">&nbsp;</span>
			<span>&nbsp;</span>
		</div>
		<div
			class="d-flex justify-content-center align-items-center w-100 h-100 my-2"
		>
			<h5>Good job! All damages have been reviewed.</h5>
		</div>
	</div>
{:else if !!caseManagement}
	{#if isOpen && lightbox}
		<Lightbox
			on:click={() => {
				isOpen = false;
			}}
			{idx}
		/>
	{/if}
	<div
		class="d-flex flex-column review-container p-3 mr-1"
		style="height: fit-content;"
	>
		<CustomInfiniteSelect
			placeholder="Choose report"
			{options}
			{value}
			onChange={onSelectReport}
			{onLoadMore}
			showNavArrows={true}
		/>

		<div class="info-category d-flex flex-row gap-5">
			<div class="d-flex flex-column my-2 py-2 me-2">
				<span class="description"> Booking ID & Report Type </span>
				<span>
					{data.bookingNo} ({splitCamelCaseAndCapitalize(
						data.reportType
					)})
				</span>
			</div>
			<div class="d-flex flex-column my-2 py-2">
				<span class="description"> Case No</span>
				<span
					class="link link-text"
					on:keydown={() => {}}
					on:click={() =>
						// navigate(`/car-management/details/${vehicleId}`)}
						// console.log(data)
						{}}
				>
					{data?.caseNo || ""}
				</span>
				<!-- <span>
					{data.bookingNo} ({splitCamelCaseAndCapitalize(data.type)})
				</span> -->
			</div>
		</div>
		<div style="height: 80%;">
			<div class="d-flex justify-content-center w-100 my-2">
				<!-- <span>Front</span> -->
				{data.images && data.images.length > 0
					? splitCamelCaseAndCapitalize(data.images[idx].imgSide)
					: ""}
			</div>
			<div
				class="d-flex justify-content-between w-100 my-2 damage-image-container"
			>
				<img
					src="/assets/icon-chevron-left-thin.svg"
					alt="left-arrow"
					class="arrow"
					as="button"
					on:click={() => {
						if (idx > 0) {
							idx--;
						}
					}}
					on:keydown={() => {}}
				/>
				<div
					on:click={() => handleOpenLightBox(idx, data.images)}
					on:keydown={() => {}}
					class="image-wrapper"
				>
					{#if data.images && data.images.length > 0}
						<img
							src={data.images[idx].imgUrl}
							alt={data.images[idx].imgSide}
							class="damage-image"
						/>
						<!-- FOR TESTING -->
						<!-- <img
							src={imgsrc}
							alt={data.images[idx].imgSide}
							class="damage-image"
						/> -->

						{#if boxes && boxes[idx]}
							<div
								class="bounding-box"
								style="
										left: {(boxes[idx][0] / origShape[1]) * 100}%;
										top: {(boxes[idx][1] / origShape[0]) * 100}%;
										width: {((boxes[idx][2] - boxes[idx][0]) / origShape[1]) * 100}%;
										height: {((boxes[idx][3] - boxes[idx][1]) / origShape[0]) * 100}%;
									"
							/>
						{/if}
					{/if}
				</div>
				<img
					src="/assets/icon-chevron-right-thin.svg"
					alt="right-arrow"
					class="arrow"
					as="button"
					on:click={() => {
						if (idx < data.images.length - 1) {
							idx++;
						}
					}}
					on:keydown={() => {}}
				/>
			</div>
			{#if data.images && data.images.length > 0}
				<div class="d-flex flex-column mt-3">
					<label class="radio-option px-5">
						<input
							type="radio"
							value="none"
							on:change={(e) => handleAttributionChange(e)}
							bind:group={data.images[idx].damageAttribute}
						/>
						<span>No attribution needed</span>
					</label>

					<label class="radio-option px-5">
						<input
							type="radio"
							value="bid"
							on:change={(e) => handleAttributionChange(e)}
							bind:group={data.images[idx].damageAttribute}
						/>
						<span>Attribute new damage to this BID</span>
					</label>

					<label class="radio-option px-5">
						<input
							type="radio"
							value="unknown"
							on:change={(e) => handleAttributionChange(e)}
							bind:group={data.images[idx].damageAttribute}
						/>
						<span>Attribute new damage to unknown</span>
					</label>
				</div>
			{/if}
			<div
				class="d-flex align-items-end justify-content-center desc-container"
			>
				{#if data.images && data.images.length > 0}
					{#each data.images as image, i}
						<img
							src={image.imgUrl}
							alt={image.imgSide}
							class="damages-image"
							on:click={() => {
								idx = i;
							}}
							on:keydown={() => {}}
						/>
					{/each}
				{/if}
			</div>
		</div>
	</div>
{:else}
	{#if isOpen && lightbox}
		<Lightbox
			{boxes}
			{origShape}
			{changeIdx}
			on:click={() => {
				isOpen = false;
			}}
			{idx}
		/>
	{/if}
	<div
		class="d-flex flex-column review-container p-3 mr-1"
		style="height: fit-content;"
	>
		<h4 class="d-flex justify-content-center w-100 my-2">
			<b> {title} </b>
		</h4>
		<div class="d-flex flex-column my-2 py-2 info-category">
			<span class="description"> Booking ID & Report Type </span>
			<span>
				{data.bookingNo} ({splitCamelCaseAndCapitalize(data.type)})
			</span>
		</div>
		<div style="height: 80%;">
			<div class="d-flex justify-content-center w-100 my-2">
				<!-- <span>Front</span> -->
				{data.images && data.images.length > 0
					? splitCamelCaseAndCapitalize(data.images[idx].imgSide)
					: ""}
			</div>
			<div
				class="d-flex justify-content-between w-100 my-2 damage-image-container"
			>
				<img
					src="/assets/icon-chevron-left-thin.svg"
					alt="left-arrow"
					class="arrow"
					as="button"
					on:click={() => {
						if (idx > 0) {
							idx--;
						}
					}}
					on:keydown={() => {}}
				/>
				<div
					on:click={() => handleOpenLightBox(idx, data.images)}
					on:keydown={() => {}}
					class="image-wrapper"
				>
					{#if data.images && data.images.length > 0}
						<div class="image-wrapper">
							<img
								src={data.images[idx].imgUrl}
								alt={data.images[idx].imgSide}
								class="damage-image"
							/>
							{#if boxes.length > 0 && origShape.length > 0}
								{#each boxes as box}
									<span
										class="bounding-box"
										style="
                                        left: {(box[0] / origShape[1]) * 100}%;
						top: {(box[2] / origShape[0]) * 100}%;
						width: {((box[1] - box[0]) / origShape[1]) * 100}%;
						height: {((box[3] - box[2]) / origShape[0]) * 100}%;"
									/>
								{/each}
							{/if}
						</div>
					{/if}
				</div>
				<img
					src="/assets/icon-chevron-right-thin.svg"
					alt="right-arrow"
					class="arrow"
					as="button"
					on:click={() => {
						if (idx < data.images.length - 1) {
							idx++;
						}
					}}
					on:keydown={() => {}}
				/>
			</div>
			<div
				class="d-flex align-items-end justify-content-center desc-container"
			>
				{#if data.images && data.images.length > 0}
					{#each data.images as image, i}
						<img
							src={image.imgUrl}
							alt={image.imgSide}
							class="damages-image"
							on:click={() => {
								idx = i;
							}}
							on:keydown={() => {}}
						/>
					{/each}
				{/if}
			</div>
		</div>
	</div>
{/if}

<style>
	.image-wrapper {
		position: relative;
		display: inline-block;
	}
	.description {
		color: var(--fds-on-surface-variant);
	}

	.review-container {
		border: 1px solid #e8e8e8;
		border-radius: 8px;
	}

	.info-category {
		border-bottom: 1px solid #e8e8e8;
	}

	.damage-image-container {
		height: 90%;
	}

	.damage-image {
		height: -webkit-fill-available;
		width: 100%;
		object-fit: cover;
		display: block;
		max-width: 100%;
	}

	.damages-image {
		height: 40px;
		width: 40px;
		margin: 0 2px;
	}

	img:hover {
		cursor: pointer;
	}
	.arrow {
		width: 30px;
		margin: 0 10px;
	}

	.desc-container {
		margin: 36px 0;
	}

	:global(.bounding-box) {
		position: absolute;
		border: 2px solid red;
		pointer-events: none;
	}
</style>
